module.exports = __webpack_public_path__ + "img/picture-11.10023b17.png";